import axios from 'axios';
import { API_ENDPOINTS } from '../config/apiConfig';

interface LoginRequest {
  phoneNumber: string;
  securityPin: string;
}

interface UserData {
  id: string;
  userName: string;
  fullName: string;
  percentProfile: number;
  email: string | null;
  phoneNumber: string;
  emailVerified: boolean;
  phoneNumberVerified: boolean;
  userRole: string;
  profileImageurl: string | null;
  isPlatformAdmin: boolean | null;
  currentSchoolRole: string | null;
  isSuperAdmin: boolean | null;
  initializeStep: number;
  lastUsedSchoolId: string | null;
  existingUser: any | null;
}

interface LoginResponse {
  message: string;
  success: boolean;
  data: {
    access_token: string;
    token_type: string;
    refresh_token: string | null;
  } & UserData;
}

export const authService = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    // Call the student authentication endpoint in school-service
    const response = await axios.post(`${API_ENDPOINTS.schoolApi}/students/auth/login`, {
      phoneNumber: credentials.phoneNumber,
      securityPin: credentials.securityPin
    });

    // Transform the response to match the expected format
    if (response.data.success) {
      const authData = response.data.data;
      return {
        success: true,
        message: response.data.message,
        data: {
          access_token: authData.accessToken,
          token_type: "Bearer",
          refresh_token: authData.refreshToken,
          id: authData.userId,
          userName: authData.userId, // Use userId as userName
          fullName: authData.fullName,
          email: authData.email,
          phoneNumber: credentials.phoneNumber,
          userRole: authData.role,
          // Add other expected fields
          percentProfile: 100,
          emailVerified: authData.emailVerified,
          phoneNumberVerified: authData.phoneNumberVerified,
          profileImageurl: null,
          isPlatformAdmin: false,
          currentSchoolRole: null,
          isSuperAdmin: false,
          initializeStep: 0,
          lastUsedSchoolId: null,
          existingUser: null
        }
      };
    }

    return response.data;
  },
};